import retailerLogo0 from '../assets/retailers/AmazonLogo.png';
import retailerLogo1 from '../assets/retailers/scheels-logo.svg';
import retailerLogo2 from '../assets/retailers/best-buy-logo.jpg';
import retailerLogo3 from '../assets/retailers/acme-tools-logo.svg';
import retailerLogo4 from '../assets/retailers/rei-logo.svg';
import retailerLogo5 from '../assets/retailers/home-depot-logo.svg';
import retailerLogo6 from '../assets/retailers/baits-logo.png';
import retailerLogo7 from '../assets/retailers/bass-pro-logo.svg';
import retailerLogo8 from '../assets/retailers/CabelasLogo.png';
import retailerLogo9 from '../assets/retailers/sportsmans-warehouse-logo-trimmed.png';
import retailerLogo10 from '../assets/retailers/HDInnovations.png';
import retailerLogo11 from '../assets/retailers/SummitFishing.png';
import retailerLogo12 from '../assets/retailers/West_Marine_logo_logotype.webp';
import fishUsaLogo from '../assets/retailers/fishusa-logo-2026.png';
import sportsmansGuideLogo from '../assets/retailers/sportsmans-guide-logo-2026.png';


// Local marks use content-hashed URLs to replace stale assets on deployment.
export const RETAILER_LOGOS = {
  "Amazon": retailerLogo0,
  "Scheels": retailerLogo1,
  "Best Buy": retailerLogo2,
  "Acme Tools": retailerLogo3,
  "REI": retailerLogo4,
  "The Home Depot": retailerLogo5,
  "Home Depot": retailerLogo5,
  "Baits.com": retailerLogo6,
  "Bass Pro": retailerLogo7,
  "Cabela's": retailerLogo8,
  "FishUSA": fishUsaLogo,
  "Sportsman's Warehouse": retailerLogo9,
  "Sportsman's Guide": sportsmansGuideLogo,
  "Amped Outdoors": "https://ampedoutdoors.com/cdn/shop/files/Amped_Outdoors_LITHIUM_b31b579c-5858-4e86-bae1-14df90eef9e1.png",
  "HD Innovations": retailerLogo10,
  "Summit Fishing Equipment": retailerLogo11,
  "West Marine": retailerLogo12
};

export function getRetailerLogo(name) {
  if (name==='Best Buy Marketplace') return RETAILER_LOGOS['Best Buy'];
  const normalize=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
  const key=Object.keys(RETAILER_LOGOS).find(retailer=>normalize(retailer)===normalize(name));
  return key ? RETAILER_LOGOS[key] : null;
}
